import { Navigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

const NavigateToIncidences = () => {
  const { navigation } = useNavigation()

  return <Navigate replace to={navigation.bookkeepers.incidences.fullPath()} />
}

export default NavigateToIncidences
